module.exports = __webpack_public_path__ + "img/card-vital-tab.678c9f35.webp";